<template>
  <div class="background-pattern">
    <div class="page-container background-image" ref="back">
      <div class="main-content">
        <slot class=""></slot>
      </div>
      <div class="footer-content">
        <p class="copyright">© Copyright {{ new Date().getFullYear() }} Parcelex</p>
      </div>
    </div>
  </div>
</template>

<script>
export default ({
  name: 'NewLayout',
  components: {
  },
  data() {
    return {
      width: window.innerWidth,
      teste: 0,
    };
  },
  props: {
    backgroundImage: {
      type: String,
    },
    backgroundImage2x: {
      type: String,
    },
    showLogo: {
      type: Boolean,
      value: true,
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.width = window.innerWidth;
      const back = this.$refs.back.style;
      if (this.width > 1000) {
        back.backgroundImage = `url(${this.backgroundImage})`;
        back.backgroundImage = `-webkit-image-set(url(${this.backgroundImage}) 1x, url(${this.backgroundImage2x}) 2x)`;
      } else {
        back.backgroundImage = 'none';
      }
    },
  },
});
</script>

<style lang='scss' scoped>
  *, *::before, *::after {
    box-sizing: border-box;
  }
  .background-pattern {
    background-color: var(--color-primary);
    background: url('https://cdn.parcelex.com.br/assets/v3/abstract/pattern.png'), linear-gradient(45deg, #00A7C8 0%, #12C6E5 52%, #01A4C9 90%);
    background-size: cover;
    background-blend-mode: multiply;
    background-repeat: no-repeat;
    background-position: bottom right;
    background-attachment: fixed;
    overflow: hidden;
    min-height: 100vh;
    display: flex;
  }
  .background-image{
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: bottom -1px right;
    background-size: contain;
    @media (min-width: 1600px) {
      background-position: bottom -1px right 20%;
    }
    @media (min-width: 2000px) {
      background-position: bottom -1px right 30%;
    }
  }
  .page-container{
    display: flex;
    flex-direction: column;
    min-height: 100%;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;
    line-height: 1.5;
    flex-wrap: nowrap;
    @media (min-width: $md){
      padding: 0;
    }
    @media (min-width: 1600px){
      max-width: 1300px;
    }
    @media (min-width: 1980px){
      max-width: 1600px;
    }
  }
  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media (min-width: 1000px) and (max-width: 1400px) {
      padding-left: 1.5rem;
    }
  }
  .footer-content {
    padding: 1.5rem;
    color: white;
    text-align: left;

    @media (max-width: 1000px) {
      display: flex;
      align-self: center;
      justify-content: center;
      padding: 0 0 1.5rem;
    }
  }
</style>

<style lang="scss">
  @import url("https://use.typekit.net/ioq1obq.css");
  @import url("https://use.typekit.net/vtp2byb.css");
  :root {
    --color-primary: #36A3CA;
    --color-primary-600: #2B83A2;
    --color-gray-300: #CBD5E1;
    --color-gray-500: #64748B;
    --shadow-color: 196deg 58% 37%;
    --shadow-elevation-low:
      0px 0.5px 0.6px hsl(var(--shadow-color) / 0.2),
      0px 0.7px 0.8px -1.2px hsl(var(--shadow-color) / 0.2),
      0px 1.6px 1.8px -2.5px hsl(var(--shadow-color) / 0.2);
    --shadow-elevation-medium:
      0px 0.5px 0.6px hsl(var(--shadow-color) / 0.21),
      0px 1.4px 1.6px -0.8px hsl(var(--shadow-color) / 0.21),
      0px 3.3px 3.7px -1.7px hsl(var(--shadow-color) / 0.21),
      0.1px 7.8px 8.8px -2.5px hsl(var(--shadow-color) / 0.21);
    --shadow-elevation-high:
      0px 0.5px 0.6px hsl(var(--shadow-color) / 0.2),
      0px 1.9px 2.1px -0.4px hsl(var(--shadow-color) / 0.2),
      0px 3.4px 3.8px -0.7px hsl(var(--shadow-color) / 0.2),
      0px 5.4px 6.1px -1.1px hsl(var(--shadow-color) / 0.2),
      0.1px 8.5px 9.6px -1.4px hsl(var(--shadow-color) / 0.2),
      0.1px 13.2px 14.9px -1.8px hsl(var(--shadow-color) / 0.2),
      0.1px 19.9px 22.4px -2.1px hsl(var(--shadow-color) / 0.2),
      0.2px 29.3px 33px -2.5px hsl(var(--shadow-color) / 0.2);
  }
  body {
    font-family: 'Usual', system-ui, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    h1,h2,h3,h4 {
      font-family: 'Arboria', system-ui, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
    }
  }
</style>
